import { ReactNode, MouseEvent } from 'react'
import { InfoCircleFilled } from '@ant-design/icons'
import { DELETE_DFM_REPORT } from '@Admin/AdminQuotingPage/constants'

import Box from '~/core/Box'
import Popover from '~/core/Popover'
import Text from '~/core/Text'
import Button from '~/core/Button'
import colors from '~/styles/_colors.css'

type DeleteDfmReportPopoverType = {
    children: ReactNode
    onClickConfirm: Function
    onClickCancel: (evt: MouseEvent) => void
    onVisibleChange: (visible: boolean) => void
    visible: boolean
}

export default function DeleteDfmReportPopover(
    props: DeleteDfmReportPopoverType,
) {
    const {
        children,
        onClickConfirm,
        onClickCancel,
        onVisibleChange,
        visible,
    } = props

    const content = (
        <Box width="310px" padding="4px">
            <Box direction="col">
                <InfoCircleFilled
                    style={{ color: colors.warning, margin: '2px 8px 0 0' }}
                />
            </Box>
            <Box direction="col">
                <Text fontSize="14px" fontWeight={300} color="blackAlpha65">
                    Are you sure you want to delete this report?
                </Text>
                <Box direction="row" marginTop="16px" justifyContent="end">
                    <Button
                        data-test-target={`cancel-${DELETE_DFM_REPORT}`}
                        name="cancel"
                        placement={DELETE_DFM_REPORT}
                        onClick={onClickCancel}
                        style={{ marginRight: '4px' }}
                        size="small"
                    >
                        Cancel
                    </Button>
                    <Box>
                        <Button
                            data-test-target={DELETE_DFM_REPORT}
                            name="delete"
                            placement={DELETE_DFM_REPORT}
                            onClick={onClickConfirm}
                            type="primary"
                            size="small"
                        >
                            Delete report
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    )

    return (
        <Popover
            placement="topRight"
            content={content}
            visible={visible}
            onVisibleChange={onVisibleChange}
        >
            {children}
        </Popover>
    )
}
